import * as React from 'react'

import Svg, { Path } from 'react-native-svg'

import { IconProps } from '../icons'

const DOB = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 3.22a.8.8 0 0 1 .8.8v1.19h6.25V4.02a.8.8 0 0 1 1.6 0v1.19h.87a3.5 3.5 0 0 1 3.49 3.49v8.5a3.5 3.5 0 0 1-3.49 3.49H6.49A3.5 3.5 0 0 1 3 17.2V8.7a3.5 3.5 0 0 1 3.49-3.49h.71V4.02a.8.8 0 0 1 .8-.8Zm9.51 3.6c1.04 0 1.89.85 1.89 1.89v8.5c0 1.04-.85 1.89-1.89 1.89H6.49c-1.04 0-1.89-.85-1.89-1.89V8.7c0-1.04.85-1.89 1.89-1.89h11.03l-.01.01Z"
      fill={color}
    />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.56 10.48c0-.03-.02-.09-.02-.09l.01-.01a1.559 1.559 0 0 0-.146-.319c-.087-.157-.174-.314-.174-.501 0-.021.003-.04.005-.057.003-.015.005-.03.005-.043-.16.03-.35.13-.47.23-.31.26-.4.7-.29 1.08.03.11.07.22.15.3.08.08.18.15.29.16.39.05.69-.4.64-.75Zm.01 1.01h-1.14a.19.19 0 0 0-.19.19v1.87c0 .105.085.19.19.19h1.14a.19.19 0 0 0 .19-.19v-1.87a.19.19 0 0 0-.19-.19Zm3.38 4.04h-.96s.01-.03.01-.05v-1.12c0-.19-.16-.35-.35-.35H9.36c-.19 0-.35.16-.35.35v1.12s0 .04.01.05h-.96a.48.48 0 0 0-.48.48v1.34c0 .27.22.48.48.48h7.91c.27 0 .48-.22.48-.48v-1.34a.48.48 0 0 0-.48-.48h-.02Z"
      fill={color}
    />
  </Svg>
)

export default DOB
